import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFacebook, faTwitter, faLinkedin } from "@fortawesome/free-brands-svg-icons";

function Footer() {
  return (
    <footer className="bg-gradient-to-r from-lime-300 via-lime-600 to-green-900 text-white shadow-inner">
      <div className="container mx-auto px-6 sm:px-12 py-8 flex flex-col md:flex-row justify-between items-center gap-y-6">

        {/* Footer Links */}
        <div className="text-center md:text-left">
          <ul className="flex flex-col sm:flex-row sm:space-x-12 space-y-2 sm:space-y-0 text-base font-medium">
            <li>
              <a href="/privacy" className="hover:text-yellow-400 transition-colors duration-300">
                Privacy Policy
              </a>
            </li>
            <li>
              <a href="/terms" className="hover:text-yellow-400 transition-colors duration-300">
                Terms of Service
              </a>
            </li>
            <li>
              <a href="/contact" className="hover:text-yellow-400 transition-colors duration-300">
                Contact Us
              </a>
            </li>
          </ul>
        </div>

        {/* Social Icons */}
        <div className="flex space-x-6">
          <a
            href="https://facebook.com"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Facebook"
            className="text-2xl hover:text-blue-500 transform hover:scale-110 transition-transform duration-300"
          >
            <FontAwesomeIcon icon={faFacebook} />
          </a>
          <a
            href="https://twitter.com"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Twitter"
            className="text-2xl hover:text-blue-400 transform hover:scale-110 transition-transform duration-300"
          >
            <FontAwesomeIcon icon={faTwitter} />
          </a>
          <a
            href="https://linkedin.com"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="LinkedIn"
            className="text-2xl hover:text-blue-600 transform hover:scale-110 transition-transform duration-300"
          >
            <FontAwesomeIcon icon={faLinkedin} />
          </a>
        </div>
      </div>

      {/* Copyright */}
      <div className="text-center py-4 border-t border-lime-500/40 mt-6">
        <p className="text-sm font-light opacity-90 hover:opacity-100 transition-opacity duration-300">
          © {new Date().getFullYear()} Proalgenix. All rights reserved.
        </p>
      </div>
    </footer>
  );
}

export default Footer;
